module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "locations"
  }, [_c('div', {
    staticClass: "controls"
  }, [_c('FilterLocations')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b5e2ca6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Locations.vue
// module id = 418
// module chunks = 1